module.exports = __webpack_public_path__ + "images/pipelinedeals-logo-transparent.png";